import React from 'react';
import { Navigate, Route, useLocation, useParams } from 'react-router-dom';
import basePath from 'utils/basePath';

const OverviewRedirect = () => {
  const location = useLocation();
  const { country, city } = useParams<{
    country?: string;
    city?: string;
  }>();
  const segments = [basePath, 's'];

  if (country) {
    segments.push(country);
  }

  if (city) {
    segments.push(city);
  }

  const destination = segments.join('/');

  return (
    <Navigate
      to={`${destination}${location.search}`}
      replace
      state={location.state}
    />
  );
};

const OverviewPageRoutes = (
  <Route
    key={'overview-redirect'}
    path={`${basePath}/overview/:country?/:city?`}
    element={<OverviewRedirect />}
  />
);

export default OverviewPageRoutes;
